@if (loading) {
  <motn-spinner></motn-spinner>
}

@if (!loading) {
  @if (table$ | async; as table) {
    <motn-sort-table
      [hidden]="table.rows.length === 0"
      [table$]="table$"
    ></motn-sort-table>

    @if (table.rows.length === 0) {
      <div class="empty-state-container">
        <i class="empty-state-icon fa-regular fa-magnifying-glass"></i>
        <p class="empty-state-text">{{ searchTerm || filters ? 'No devices match your search' : 'No devices found' }}</p>
      </div>
    }
  }
}

@if (editingDevice) {
  <motn-device-editor
    [deviceId]="editingDevice"
    (clickedOutside$)="editingDevice = null"
  ></motn-device-editor>
}

@if (bacnetDiscoveryDevice) {
  <motn-bacnet-point-discovery
    [preselectedDevice]="bacnetDiscoveryDevice"
    (clickedOutside$)="bacnetDiscoveryDevice = null"
  ></motn-bacnet-point-discovery>
}

@if (modbusConfigureDevice) {
  <motn-modbus-point-editor
    [preselectedDevice]="modbusConfigureDevice"
    (clickedOutside$)="modbusConfigureDevice = null"
  ></motn-modbus-point-editor>
}

@if (lorawanPointsDevice) {
  <motn-lorawan-points
    [preselectedDevice]="lorawanPointsDevice"
    (clickedOutside$)="lorawanPointsDevice = null"
  ></motn-lorawan-points>
}

@if (editingHub) {
  <motn-hub-editor
    [hubId]="editingHub"
    (saved$)="editingHub = null"
    (clickedOutside$)="editingHub = null"
  ></motn-hub-editor>
}
